export const WALLET_BALANCE_VISIBLE_KEY = "walletBalanceVisible";

export const WALLET_BALANCE_VISIBILITY_EVENT = "walletBalanceVisibilityChanged";

export const readWalletBalanceVisible = (): boolean => {
  try {
    const raw = localStorage.getItem(WALLET_BALANCE_VISIBLE_KEY);
    if (raw === null) return false;
    return raw === "true";
  } catch {
    return false;
  }
};

export const writeWalletBalanceVisible = (visible: boolean): void => {
  try {
    localStorage.setItem(WALLET_BALANCE_VISIBLE_KEY, String(visible));
    window.dispatchEvent(
      new CustomEvent(WALLET_BALANCE_VISIBILITY_EVENT, { detail: visible })
    );
  } catch {
    // ignore quota / private mode
  }
};
